import React from 'react'

const Home = React.lazy(() => import("./views/Home"))
const Activate = React.lazy(() => import("./views/Activate"))
// const HomeSimba = React.lazy(() => import("./views/HomeSimba"))
const HiddenPage = React.lazy(() => import("./views/Hiddenpage"))
const Landing = React.lazy(() => import('./views/personal-plan/Landing'))
const MY130 = React.lazy(() => import('./views/personal-plan/SimPlanMy130'))
const SR50GB_30 = React.lazy(() => import('./views/personal-plan/SR50GB_30'))
const Simba = React.lazy(() => import('./views/personal-plan/SimbaSuperRoam'))
const SimPlan80 = React.lazy(() => import('./views/personal-plan/SimPlan80'))
const SimPrepaid = React.lazy(() => import('./views/personal-plan/SimPrepaid'))
const SimSenior = React.lazy(() => import('./views/personal-plan/SimSenior'))
const Faq = React.lazy(() => import('./views/Faq'))
const Personal = React.lazy(() => import('./views/Personal'))
const TPG = React.lazy(() => import('./views/TPG'))
const Business = React.lazy(() => import('./views/Business'))
const Bo50GB = React.lazy(() => import("./views/business-plan/BoPlan50"))
const Bo80GB = React.lazy(() => import("./views/business-plan/BoPlan80"))
const FiveG = React.lazy(() => import('./views/FiveG'))
const FiveGBundle = React.lazy(() => import("./views/FiveGBundle"))
const PressRelease = React.lazy(() => import('./views/util-page/PressRelease'))
const Careers = React.lazy(() => import("./views/util-page/Careers"))
const CareerTerms = React.lazy(() => import("./views/util-page/CareerTerms"))
const Cis = React.lazy(() => import("./views/util-page/CIS"))
const UserGuide = React.lazy(() => import("./views/util-page/UserGuide"))
const Complaint = React.lazy(() => import("./views/util-page/Complaint"))
const CisIDD = React.lazy(() => import("./views/util-page/CISIDD"))
const CisNEWIDD = React.lazy(() => import("./views/util-page/CISNEWIDD"))
const Alert = React.lazy(() => import("./views/util-page/Alert"))
const Volte = React.lazy(() => import("./views/util-page/Volte"))
const Roaming = React.lazy(() => import("./views/util-page/Roaming"))
// const RoamingOld = React.lazy(() => import("./views/util-page/RoamingOld"))
const SgApp = React.lazy(() => import("./views/util-page/SgApp"))
const VoiceApp = React.lazy(() => import("./views/util-page/VoiceApp"))
const DataProtection = React.lazy(() => import("./views/util-page/DataProtection"))
const Collect = React.lazy(() => import("./views/util-page/Collect"))
const Walkin = React.lazy(() => import("./views/util-page/Walkin"))
const Idd = React.lazy(() => import("./views/util-page/IDD"))
const Terms = React.lazy(() => import("./views/util-page/Terms"))
const SeniorsSignUpNew = React.lazy(() => import("./views/personal-plan/sim-senior/SignUpNew"))
const LuckyNumber = React.lazy(() => import("./views/util-page/LuckyNumber"))
const Account = React.lazy(() => import("./views/Account"))
const WirelessSg = React.lazy(() => import("./views/util-page/WirelessSg"))
const Prohibited = React.lazy(() => import("./views/util-page/Prohibited"))
const SuperIddPack = React.lazy(() => import("./views/personal-plan/SuperIddPack"))
const Forms = React.lazy(() => import("./views/util-page/Forms"))
const Esim = React.lazy(() => import('./views/util-page/ESim'))
const GiveawayCampaign = React.lazy(() => import('./views/util-page/GiveawayCampaign'))
const Wifi = React.lazy(() => import('./views/util-page/Wifi'))

// Chinese New Year
const Promo = React.lazy(() => import("./views/cny/Promo"))
const Birthday = React.lazy(() => import("./views/cny/Birthday"))
const HuatAh = React.lazy(() => import("./views/cny/HuatAh"))
const FreeTShirt = React.lazy(() => import("./views/cny/FreeTShirt"))

// FBB
const Broadband = React.lazy(() => import('./views/util-page/fbb/Broadband'))

const DonwloadAuthorisationLetter = React.lazy(() => import("./views/download-page/AuthorisationLetterDownload"))
const DonwloadAuthorisationCompanyLetter = React.lazy(() => import("./views/download-page/AuthorisationCompanyLetterDownload"))
const DonwloadTerminationRequest = React.lazy(() => import("./views/download-page/TerminationRequest"))

const routes = [
    {path : "/home", name : "Homepage", component : Home, exact : true},
    {path : "/activate", name : "Activate", component : Activate, exact : true},
    // {path : "/homesimba", name : "Homepage", component : HomeSimba, exact : true},
    {path : "/hiddenpage", name : "Hidden", component : HiddenPage, exact : true},
    {path : "/account", name : "Account", component : Account, exact : true},
    {path : "/50gb-sim-only-plan", name : "SimPlan50", component : Landing, exact : true},
    {path : "/130gb-my-sim-only-plan", name : "SimPlanMY130", component : MY130, exact : true},
    {path : "/simba-super-roam", name : "Simba Super Roam", component : Simba, exact : true},
    {path : "/80gb-sim-only-plan", name : "SimPlan80", component : SimPlan80, exact : true},
    {path : "/50gb-prepaid-plan", name : "SimPrepaid", component : SimPrepaid, exact : true},
    {path : "/sr2030-my-sim-only-plan", name : "SimPlanSR2030", component : SR50GB_30, exact : true},
    {path : "/seniors-sim-only-plan", name : "Seniors", component : SimSenior, exact : true},
    {path : "/seniors-signup-new", name : "Seniors Sign Up New", component : SeniorsSignUpNew, exact : true},
    {path : "/faqs", name : "Faq", component : Faq, exact : true},
    {path : "/personal", name : "Personal", component : Personal, exact : true},
    {path : "/tpg", name : "SIMBA", component : TPG, exact : true},
    {path : "/50gb-business-plan", name : "Business", component : Bo50GB, exact : true},
    // {path : "/business", name : "Business", component : Business, exact : true},
    // {path : "/business-50gb-plan", name : "Business Plan 50GB", component : Bo50GB, exact : true},
    // {path : "/business-80gb-plan", name : "Business Plan 80GB", component : Bo80GB, exact : true},
    {path : "/5G", name : "5G", component : FiveG, exact : true},
    {path : "/5G-bundle", name : "5G", component : FiveGBundle, exact : true},
    {path : "/press-release", name : "Press Release", component : PressRelease, exact : true},
    {path : "/careers", name : "Careers", component : Careers, exact : true},
    {path : "/careers-terms-and-conditions", name : "Careers Terms and Conditions", component : CareerTerms, exact : true},
    {path : "/cis", name : "CIS", component : Cis, exact : true},
    {path : "/guide", name : "User Guide", component : UserGuide, exact : true},
    {path : "/complaint-handling-policy", name : "Complaint Handling Policy", component : Complaint, exact : true},
    // {path : "/80GB-IDD", name : "CIS 80GB IDD", component : CisIDD, exact : true},
    {path : "/IDD-Destinations", name : "CIS Destinations IDD", component : CisNEWIDD, exact : true},
    {path : "/Alert", name : "Alert", component : Alert, exact : true},
    {path : "/volte", name : "VoLTE", component : Volte, exact : true},
    // {path : "/new-roaming", name : "Roaming", component : Roaming, exact : true},
    {path : "/roaming", name : "Roaming", component : Roaming, exact : true},
    {path : "/mysimba", name : "TPG SG App", component : SgApp, exact : true},
    {path : "/voiceapp", name : "TPG 4G Voice App", component : VoiceApp, exact : true},
    {path : "/data-protection-notice", name : "Data Protection Notice", component : DataProtection, exact : true},
    {path : "/collect", name : "SIM Pick-up and Activation", component : Collect, exact : true},
    {path : "/walk-in", name : "Walk-in to Sign up, Renew and Recharge", component : Walkin, exact : true},
    {path : "/idd", name : "IDD Rates and International SMS", component : Idd, exact : true},
    {path : "/terms", name : "TPG Mobile Terms and Conditions", component : Terms, exact : true},
    {path : "/lucky-number", name : "Lucky Number", component : LuckyNumber, exact : true},
    {path : "/wireless-sg", name : "Wireless SG", component : WirelessSg, exact : true},
    {path : "/prohibited", name : "Prohibited", component : Prohibited, exact : true},
    {path : "/super-IDD", name : "SIMBA Super IDD Pack", component : SuperIddPack, exact : true},
    {path : "/forms", name : "Forms", component : Forms, exact : true},
    {path : "/broadband", name : "Broadband", component : Broadband, exact : true},
    {path : "/esim", name : "ESIM", component : Esim, exact : true},
    {path : "/wifi", name : "Wifi", component : Wifi, exact : true},
    {path : "/ilovesimba", name : "I Love SIMBA", component : GiveawayCampaign, exact : true},

    // Chinese New Year
    {path : "/promo", name : "Promo", component : Promo, exact : true},
    {path : "/birthday", name : "Birthday", component : Birthday, exact : true},
    {path : "/huat-ah", name : "Huat Ah", component : HuatAh, exact : true},
    {path : "/free-t-shirt", name : "Free T Shirt", component : FreeTShirt, exact : true},

    // Download File
    {path : "/download/authorisation-letter", name : "Download Authorisation-Letter", component : DonwloadAuthorisationLetter, exact : true},
    {path : "/download/authorisation-company-letter", name : "Download Authorisation-Company-Letter", component : DonwloadAuthorisationCompanyLetter, exact : true},
    {path : "/download/account-termination-acknowledgement-Form", name : "Download Account Termination Acknowledgement Form", component : DonwloadTerminationRequest, exact : true},
]

export default routes